export enum FrontAppEnum {
  CMS = 'cms',
  CLIENT = 'client'
}
